(ns minorodata.components.infinite-scroll.core
  (:require [reagent.core :as reagent]
            [applied-science.js-interop :as j]
            [goog.functions :refer [debounce]]))


(def pixels-before-end 50)
(def debounce-timeout 50)

(def track-scroll-end
  (debounce (fn [action event]
              (let [target       (j/get event :target)
                    scrollHeight (j/get target :scrollHeight)
                    scrollTop    (j/get target :scrollTop)
                    offsetHeight (j/get target :offsetHeight)]
                (when (<= scrollHeight (+ scrollTop offsetHeight pixels-before-end))
                  (action))))
            debounce-timeout))


(defn start-track-scroll [element track-fn]
  (j/call element :addEventListener "scroll" track-fn))


(defn stop-track-scroll [element track-fn]
  (j/call element :removeEventListener "scroll" track-fn))


(defn infinite-scroll-render []
  (let [container (reagent/atom nil)]
    (reagent/create-class
      {:display-name
       "infinite-scroll-render"

       :component-did-mount
       (fn [this]
         (let [{:keys [track-end]} (reagent/props this)]
           (when (some? @container)
             (start-track-scroll @container track-end))))

       :component-will-unmount
       (fn [this]
         (let [{:keys [track-end]} (reagent/props this)]
           (when (some? @container)
             (stop-track-scroll @container track-end))))

       :render
       (fn [this]
         (let [{:keys [classes component component-props loader loading? node-ref]} (reagent/props this)
               children          (reagent/children this)
               children-fragment (into [:<>] children)
               original-class    (:class component-props)
               merged-props      (merge component-props
                                        {:class [(:infinite-root classes)
                                                 (when (some? original-class) original-class)]
                                         :style {:height     "100%"
                                                 :overflow-x "hidden"
                                                 :overflow-y "auto"}
                                         :ref   (fn [node]
                                                  (reset! container node)
                                                  (when node-ref (set! (.-current node-ref) node)))})]
           (if (fn? component)
             [component merged-props
              children-fragment
              (when loading? loader)]

             [:> component merged-props
              children-fragment
              (when loading? loader)])))})))


(defn main [{:keys [component component-props loader loading? node-ref on-scroll-end]}]
  (let [this     (reagent/current-component)
        children (reagent/children this)]
    (into
      [infinite-scroll-render
       {:track-end       (partial track-scroll-end on-scroll-end)
        :loader          loader
        :loading?        loading?
        :component       component
        :component-props component-props
        :node-ref        node-ref}]
      children)))
